import { UserTask } from '../types';

export const canCompleteTaskFn = (
  userId: number,
  task: UserTask,
  canCompleteAnyTask: boolean,
  isEventCollaboratorsEnabled: boolean,
): boolean => {
  const isTaskCreator = task.creator_id === userId;
  const isTaskAssignee = task.owner_id === userId;

  return isTaskAssignee || canCompleteAnyTask || (isTaskCreator && !isEventCollaboratorsEnabled);
};
